var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-container show" }, [
    _c("div", { staticClass: "panel-content" }, [
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-column align-items-center justify-content-center p-4",
        },
        [
          this.location.id > 0
            ? _c("h5", { staticClass: "mb-0 fw-700 text-center mt-3" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(this.location.title) +
                    "\n                "
                ),
              ])
            : _c("h5", { staticClass: "mb-0 fw-700 text-center mt-3" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.__t("NEW_REST")) +
                    "\n                "
                ),
              ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("div", { staticClass: "form-group mt-2" }, [
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "advanced_name" } },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.__t("REST_NAME")) +
                    "\n                    "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "input-group flex-nowrap" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.location.title,
                    expression: "location.title",
                  },
                ],
                staticClass: "form-control",
                attrs: { id: "advanced_name", type: "text" },
                domProps: { value: _vm.location.title },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.location, "title", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "panel-tag mt-2" }, [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.__t("TAKEAWAY_LOCATION_PARAMS")) +
                "\n                "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group mt-2" }, [
            _c("label", { staticClass: "form-label" }, [
              _vm._v(
                "\n                        " +
                  _vm._s(_vm.__t("API_TYPE")) +
                  "\n                    "
              ),
            ]),
            _vm._v(" "),
            _c("div", [
              _c(
                "div",
                { staticClass: "input-group flex-nowrap" },
                [
                  _c("b-form-radio-group", {
                    attrs: {
                      id: "btn-radios-1",
                      "button-variant": "outline-primary",
                      options: [
                        { text: _vm.__t("TAKE_API"), value: "api" },
                        { text: _vm.__t("TAKE_TABLET"), value: "tablet" },
                      ],
                      name: "radios-btn-default",
                      buttons: "",
                    },
                    model: {
                      value: _vm.location.general_fields["api_type"],
                      callback: function ($$v) {
                        _vm.$set(_vm.location.general_fields, "api_type", $$v)
                      },
                      expression: "location.general_fields['api_type']",
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm._l(_vm.api_params, function (general_field) {
            return _c("div", { staticClass: "form-group mt-2" }, [
              general_field.key != "api_type"
                ? _c("div", [
                    _c("label", { staticClass: "form-label" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(general_field.title) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("div", { staticClass: "input-group flex-nowrap" }, [
                        _vm._m(1, true),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value:
                                _vm.location.general_fields[general_field.key],
                              expression:
                                "location.general_fields[general_field.key]",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { id: general_field.key, type: "text" },
                          domProps: {
                            value:
                              _vm.location.general_fields[general_field.key],
                          },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.location.general_fields,
                                general_field.key,
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ])
          }),
          _vm._v(" "),
          _c("location_general_params", { attrs: { location: _vm.location } }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }